import { BTable, BFormInput } from "bootstrap-vue";

export default {
  name: "scoreSettings",
  components: {
    BTable,
    BFormInput,
  },

  data() {
    return {
      disabled: false,
      url: "admin/customers_club/get_club_scores",
      editUrl: "admin/customers_club/set_club_scores",
      items: [],
      fields: [
        {
          label: "شناسه",
          key: "id",
        },
        {
          label: "عنوان",
          key: "title",
        },
        {
          label: "بن",
          key: "bon_value",
        },
        {
          label: "امتیاز",
          key: "score_value",
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.disabled = true;
      await this.$axios
        .get(this.url)
        .then((res) => {
          this.items = res.data.data.list;
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    async submitChanges() {
      this.disabled = true;
      await this.$axios
        .put(this.editUrl, { customers_club_scores: [...this.items] })
        .then((res) => {
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};
